import {
  ConvertAndStoreAssetRequest,
  ConvertAndStoreAssetResponse,
} from "@physiofit-digital/physiofit_types";
import { getDownloadURL, getStorage, ref, uploadBytes } from "firebase/storage";
import { httpsRequest } from "../../../core/utils/httpsRequest";
import { functions } from "../../../firebaseConfig";

export const uploadDocumentImage = async (file: File, path: string) => {
  const storage = getStorage();
  const storageRef = ref(storage, path);

  const snapshot = await uploadBytes(storageRef, file);
  let downloadURL = await getDownloadURL(snapshot.ref);
  let fileType = file.type;

  if (fileType === "image/heic" || fileType === "image/heif") {
    const convertToJpeg = httpsRequest<
      ConvertAndStoreAssetRequest,
      ConvertAndStoreAssetResponse
    >(functions, "convertAndStoreAsset");
    const result = await convertToJpeg({ storagePath: path });
    downloadURL = result.downloadUrl;
    fileType = "image/jpeg";
  }

  return {
    assetUrl: downloadURL,
    type: "image" as "image",
    mimeType: fileType,
    internalName: file.name,
  };
};
